/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @nx/enforce-module-boundaries */
import { environment } from '../../../../../claims/util-environment/src/lib/environment';
// const base_url = 'http://localhost:3000';

const base_url = environment.api;
const base_url_MA = environment.myAccountAPI;
export const ApiRouter = {
  getMyAccountPlanDetails: () => {
    return `${environment.myAccountAPI}/get-plan-details`;
  },
  getPlanDetails: (planNumber: string) => {
    return `${base_url}/api/v1/plan-details/${planNumber}`;
  },
  getPlanRepair: (planNumber: string) => {
    return `${base_url}/api/v1/plan-details/${planNumber}/repair`;
  },
  getPlanHistory: (planNumber: string) => {
    return `${base_url}/api/v1/plan-details/${planNumber}/history`;
  },
  cancelClaim: (planNumber: string, claimId: string) => {
    return `${base_url}/api/v1/plan-details/${planNumber}/claims/${claimId}/cancel`;
  },
  getRebookingAppointments: (planNumber: string, claimId: string) => {
    return `${base_url}/api/v1/claim-details/${planNumber}/${claimId}/rebook-appointments`;
  },
  rebookAppointment: (planNumber: string, claimId: string) => {
    return `${base_url}/api/v1/claim-details/${planNumber}/${claimId}/rebook-appointments`;
  },
  visitAppointments: (planNumber: string, claimId: string) => {
    return `${base_url}/api/v1/claim-details/${planNumber}/${claimId}/visit-appointments`;
  },
  submitFeedback: () => {
    return `${base_url}/api/v1/feedback`;
  },
  startClaim: (planNumber: string) => {
    return `${base_url}/api/v1/plan-details/${planNumber}/start-claim`;
  },
  resumeClaim: (planNumber: string) => {
    return `${base_url}/api/v1/plan-details/${planNumber}/resume-claim`;
  },
  searchPlanDocumentKey: () => {
    return `${base_url_MA}/search-plan-document`;
  },
  downloadPlanDocument: (
    planNumber: string,
    encodeKey: any,
    encodeHash: any
  ) => {
    return `${base_url_MA}/plans/${planNumber}/plan-document/download?key=${encodeKey}&hash=${encodeHash}`;
  },
  lookupOptions: (planNumber: string, claimId: string, option: string) => {
    return `${base_url}/api/v1/plan-details/${planNumber}/claims/${claimId}/lookup/${option}`;
  },
  submitStep: (planNumber: string, claimId: string, step: string) => {
    return `${base_url}/api/v1/plan-details/${planNumber}/claims/${claimId}/submit/${step}`;
  },
};
